<template>
  <validation-observer ref="verify_form" v-slot="{invalid}">
    <div class="b-auth-title">
      {{ $t('core.auth.button.sign_up') }}
    </div>
    <z-form-group>
      <z-form-input :rules="{ email: true, required: true }" name="Email" vid="email">
        <label>
          {{ $t('core.auth.field.email') }}
        </label>
        <i-input v-model="form.email" type="email" name="email" autocomplete="on" />
      </z-form-input>
    </z-form-group>
    <z-form-group>
      <z-form-input
        :rules="{ required: true, phone: true }"
        mode="aggressive"
        vid="phone"
        name="$t('core.register.field.phone_number')"
      >
        <label>{{ $t('core.register.field.phone_number') }}</label>
        <tel-input ref="phone" v-model="form.phone" class="verification-phone-input" />
      </z-form-input>
    </z-form-group>
    <z-form-group>
      <z-form-input :name="$t('core.register.field.currency')">
        <label>{{ $t('core.register.field.currency') }}</label>
        <select-currency v-model="form.currency_id" />
      </z-form-input>
    </z-form-group>
    <z-form-group>
      <z-form-input :rules="{ accepted: true }" :name="$t('core.register.field.terms')">
        <label class="mb-0 w-100">
          <div class="row">
            <div class="col-12 d-flex justify-content-center">
              <checkbox v-model="form.rights" />
              <div class="text-white">
                {{ $t('core.register.i_agree') }}
                <a href="https://zorra.com/information/offer" target="_blank">
                  {{ $t('core.register.terms_and_conditions') }}
                </a>
              </div>
            </div>
          </div>
        </label>
      </z-form-input>
    </z-form-group>
    <i-button
      :disabled="invalid"
      class="auth-content__form__submit mt-3"
      type="primary"
      @click="submit_form"
    >
      {{ $t('core.auth.button.sign_up') }}
    </i-button>
  </validation-observer>
</template>

<script>
  import SelectCurrency from '@core/components/auth/register-form/register-form-select-currency';
  import TelInput from '@shared/components/input/input-phone-number';
  import { Currency } from '@shared/helpers/currency';
  import isEqual from 'lodash-es/isEqual';
  export default {
    components: { SelectCurrency, TelInput },
    props: {
      is_init: {
        type: Boolean,
        required: true
      },
      value: {
        type: Object,
        default: function() {
          return {};
        }
      }
    },
    data: () => ({
      form: {
        email: '',
        phone: '',
        rights: false,
        currency_id: Currency.USD_ID
      }
    }),
    watch: {
      form: {
        handler: function(value) {
          if (!isEqual(value, this.value)) {
            this.$emit('input', value);
          }
        },
        deep: true,
        immediate: true
      },
      value: {
        handler: function(value) {
          if (!isEqual(value, this.form)) {
            this.form = value;
          }
        },
        deep: true,
        immediate: false
      }
    },
    methods: {
      reset() {
        this.$refs.verify_form.reset();
      },
      async validate() {
        return await this.$refs.verify_form.validate();
      },
      focus_phone() {
        this.$nextTick(() => {
          this.$refs.phone.focus();
        });
      },
      validate_and_send_sms() {
        this.$emit('validate');
      },
      submit_form() {
        this.$emit('apply_form');
      }
    }
  };
</script>

<style lang="scss">
  .layout--auth {
    .auth-content__form {
      margin-top: 30px;
    }
  }

  .b-auth-title {
    color: #fff;
    font-family: 'Lato', 'sans-serif';
    font-size: 24px;
    line-height: 38px;
    text-align: center;
    margin-bottom: 18px;
  }

  .verification-phone-input {
    padding: 0.375rem 0.75rem;
    height: 38px;
    font-size: 1rem;
    line-height: 1.5;
    .vue-tel-input .vti__dropdown {
      height: 38px;
    }
  }
</style>
